<template>
  <v-data-table
    hide-actions
    :items="items"
    :loading="loading"
  >
    <template slot="headers">
      <tr class="row-height">
        <th
          :rowspan="1"
          :colspan="2"
          class="bordered"
        >
          {{ title }}
        </th>
      </tr>
      <tr class="row-height">
        <th class="bordered column-width">
          текущее
        </th>
        <th class="bordered column-width">
          справочник
        </th>
      </tr>
    </template>
    <template
      slot="items"
      slot-scope="props"
    >
      <tr class="row-height">
        <td class="bordered text-xs-center">
          {{
            `${$options.filters.fixedNumber(
              props.item.calculated,
              3
            )} кг/${unit}`
          }}
        </td>
        <td class="bordered text-xs-center">
          <v-layout
            justify-center
            fill-height
          >
            {{ $options.filters.fixedNumber(props.item.dictionaryWeight, 3) }}
          </v-layout>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    calculated: {
      type: Number,
      defaul: 0,
    },
    dictionaryWeight: {
      type: Number,
      defaul: 0,
    },
    title: {
      type: String,
      defaul: "",
    },
    unit: String,
    loading: Boolean,
  },
  computed: {
    items() {
      return [
        {
          calculated: this.calculated,
          dictionaryWeight: this.dictionaryWeight,
        },
      ];
    },
  },
};
</script>
<style scoped>
.bordered {
  border: 1px solid #13121222;
}
.column-width {
  width: 50%;
}
table.v-table thead tr:first-child,
table.v-table tbody td,
table.v-table tbody th,
.row-height {
  height: 14px !important;
}
</style>
